import { useState } from "react";
import { verify_pin_code_api } from "../../DAL/Users";
import toast from "react-hot-toast";
import OtpInput from "react-otp-input";
import SubmitButton from "../GeneralComponents/SubmitButton";

export default function VerifyPinCode(props) {
  const { formData, setFormData, setErrors, setFormState, handleLogin } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    const postData = { email: formData.email, otp: otp };
    const result = await verify_pin_code_api(postData);
    if (result.code === 200) {
      console.log(result.data, "result.dataresult.data");
      const { reset_token } = result.data;
      setFormData((prev) => ({ ...prev, reset_token: reset_token }));
      setFormState(2);
    } else {
      toast.error(`${result.message}`);
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="verify-pin-code">
      <div className="form-group mt-2">
        <label htmlFor="password">Enter OTP</label>
        <div className="input-wrapper">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>&nbsp;&nbsp;</span>}
            renderInput={(props) => <input {...props} />}
            shouldAutoFocus={true}
          />
        </div>
      </div>
      <div className="forget-password mt-2">
        <span className="login-forget-password" onClick={handleLogin}>
          Back to login?
        </span>
      </div>
      <SubmitButton
        isLoading={isLoading}
        btnText="Verify OTP"
        loadingText="Verifying..."
      />
    </form>
  );
}
